import { z } from 'zod/v3';
import { ASSET_CATEGORIES } from './asset.dto';

export const PERSON_ASSET_RELATIONSHIP_KINDS = [
  'DEVICE_CUSTODY',
  'APP_SEAT',
  'ACCOUNTABLE_OWNER',
  'TECHNICAL_OWNER',
  'SERVICE_ACCOUNT_OWNER',
  'OBSERVED_ACCESS',
] as const;

export const PersonAssetRelationshipKindSchema = z.enum(
  PERSON_ASSET_RELATIONSHIP_KINDS,
);
export type PersonAssetRelationshipKind = z.infer<
  typeof PersonAssetRelationshipKindSchema
>;

export const PersonAssetRelationshipStateSchema = z.enum([
  'ACTIVE',
  'REVOKED',
  'RETURNED',
  'REMOVED',
]);
export type PersonAssetRelationshipState = z.infer<
  typeof PersonAssetRelationshipStateSchema
>;

export const PersonAssetRelationshipDTOSchema = z.object({
  kind: PersonAssetRelationshipKindSchema,
  state: PersonAssetRelationshipStateSchema,
  source: z.string(),
  isObservation: z.boolean(),
  asset: z
    .object({
      id: z.string(),
      name: z.string(),
      assetType: z.string(),
      sequenceNumber: z.number(),
    })
    .nullable(),
  person: z
    .object({
      employeeId: z.string(),
      name: z.string(),
      email: z.string(),
    })
    .nullable(),
  detail: z.string().nullable(),
  firstObservedAt: z.coerce.date().nullable(),
  lastObservedAt: z.coerce.date().nullable(),
  provenance: z.object({
    model: z.string(),
    recordId: z.string(),
    sourceRef: z.string().optional(),
  }),
});

export type PersonAssetRelationshipDTO = z.infer<
  typeof PersonAssetRelationshipDTOSchema
>;

export const PersonAssetGraphQuerySchema = z.object({
  includeHistory: z.boolean().default(false),
  search: z.string().trim().max(200).optional(),
  /** Register bucket; unlinked device custody is 'devices', other unmatched rows 'other'. */
  category: z.enum(ASSET_CATEGORIES).optional(),
  limit: z.number().int().min(1).max(100).default(50),
  offset: z.number().int().min(0).default(0),
});

export type PersonAssetGraphQuery = z.infer<typeof PersonAssetGraphQuerySchema>;

export const PersonAssetGraphPageDTOSchema = z.object({
  items: z.array(PersonAssetRelationshipDTOSchema),
  total: z.number().int().min(0),
  limit: z.number().int().min(1),
  offset: z.number().int().min(0),
});

export type PersonAssetGraphPageDTO = z.infer<
  typeof PersonAssetGraphPageDTOSchema
>;
